"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ReadWriteFindControl_1 = require("./ReadWriteFindControl");
var ReadWriteRecipient_1 = require("./ReadWriteRecipient");
var addReadWriteRecipient_1 = require("../actions/addReadWriteRecipient");
var expandGroup_1 = require("../actions/expandGroup");
var focusNextRecipient_1 = require("../actions/focusNextRecipient");
var removeReadWriteRecipient_1 = require("../actions/removeReadWriteRecipient");
var showHideContactPicker_1 = require("../actions/showHideContactPicker");
var getRecipientString_1 = require("../utils/getRecipientString");
var mobx_react_1 = require("mobx-react");
var owa_contact_picker_1 = require("owa-contact-picker");
var RecipientType_1 = require("owa-recipient-common/lib/store/schema/RecipientType");
var React = require("react");
var styles = require('./ReadWriteRecipientWellWithFindControl.scss');
var classNames = require('classnames/bind').bind(styles);
var ReadWriteRecipientWellWithFindControl = /** @class */ (function (_super) {
    tslib_1.__extends(ReadWriteRecipientWellWithFindControl, _super);
    function ReadWriteRecipientWellWithFindControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFindControl = function () {
            return _this.well;
        };
        _this.setContactPickerState = function (recipientWell, isVisible) { return function () {
            showHideContactPicker_1.default(recipientWell, isVisible);
        }; };
        _this.addRecipientFromContactPicker = function (recipientWell) { return function (recipientToAdd) {
            addReadWriteRecipient_1.default(recipientWell, true /* isValid */, recipientToAdd, undefined /* newEmailAddress */, false /* resetFindResult */);
        }; };
        _this.bindWellRef = function (ref) {
            if (ref != null) {
                _this.well = ref;
            }
        };
        _this.removeRecipient = function (recipientWell) { return function (recipientToRemove, selectToRight) {
            removeReadWriteRecipient_1.default(recipientWell, recipientToRemove, selectToRight);
            if (recipientWell.recipients.length == 0) {
                _this.focus();
            }
        }; };
        _this.expandGroup = function (recipientWell) { return function (recipientToExpand) {
            expandGroup_1.default(recipientWell, recipientToExpand);
        }; };
        _this.focusNextRecipient = function (recipientWell) { return function (recipientToBlur, direction) {
            if (recipientWell.recipients.indexOf(recipientToBlur) + direction >=
                recipientWell.recipients.length) {
                _this.findControl.focus();
            }
            else {
                focusNextRecipient_1.default(recipientWell, recipientToBlur, direction);
            }
        }; };
        return _this;
    }
    ReadWriteRecipientWellWithFindControl.prototype.focus = function () {
        this.findControl.focus();
    };
    ReadWriteRecipientWellWithFindControl.prototype.render = function () {
        var _this = this;
        var _a = this.props, recipientWell = _a.recipientWell, recipientType = _a.recipientType, size = _a.size, shouldBlockForcedFocus = _a.shouldBlockForcedFocus;
        if (recipientWell) {
            var wellLabel = recipientType != RecipientType_1.RecipientType.None ? (React.createElement("div", { tabIndex: 0, onClick: this.setContactPickerState(recipientWell, !recipientWell.shouldShowContactPicker), className: styles.label }, getRecipientString_1.default(recipientType))) : null;
            var recipients = recipientWell.recipients;
            return (React.createElement("div", { className: styles.container, ref: this.bindWellRef },
                wellLabel,
                recipientWell.shouldShowContactPicker && (React.createElement(owa_contact_picker_1.ContactPickerPane, { viewState: recipientWell.contactPicker, findControlGetter: this.getFindControl, dismissContactPickerAction: this.setContactPickerState(recipientWell, false /* isVisible */), addRecipientAction: this.addRecipientFromContactPicker(recipientWell) })),
                recipients && recipients.length > 0
                    ? recipients.map(function (recipient, index) {
                        // Using an index as part of the key is sub-optimal, but the recipient array
                        // can contain duplicate data that has no other means of differentiating.
                        return (React.createElement(ReadWriteRecipient_1.default, { key: recipient.persona.EmailAddress.EmailAddress + "_" + index, viewState: recipient, removeOperation: _this.removeRecipient(recipientWell), focusNextOperation: _this.focusNextRecipient(recipientWell), size: size, expandGroupOperation: _this.expandGroup(recipientWell) }));
                    })
                    : null,
                React.createElement(ReadWriteFindControl_1.default, { recipientWell: recipientWell, size: size, className: classNames(styles.findControl, {
                        smallSize: size == 0 /* Small */,
                        regularSize: size == 1 /* Regular */,
                    }), shouldBlockForcedFocus: shouldBlockForcedFocus, ref: function (ref) { return (_this.findControl = ref); } })));
        }
        else {
            return null;
        }
    };
    ReadWriteRecipientWellWithFindControl = tslib_1.__decorate([
        mobx_react_1.observer
    ], ReadWriteRecipientWellWithFindControl);
    return ReadWriteRecipientWellWithFindControl;
}(React.Component));
exports.default = ReadWriteRecipientWellWithFindControl;
//# sourceMappingURL=ReadWriteRecipientWellWithFindControl.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/components/ReadWriteRecipientWellWithFindControl.js
// module id = 3387
// module chunks = 2 3